import React from 'react';
import { Table, Button, Space, Typography } from 'antd';
import { EyeOutlined, DeleteOutlined, SettingOutlined, MailOutlined } from '@ant-design/icons';

const { Text } = Typography;

const DanceOnTab = ({ 
  submissions, 
  loading, 
  canDelete,
  onRefresh, 
  onView, 
  onDelete,
  onConfigClick,
  onEmailTemplatesClick,
  formatDate 
}) => {
  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 80,
      responsive: ['sm']
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      render: (text, record) => <Text strong>{`${text} ${record.surname}`}</Text>,
      ellipsis: true,
      responsive: ['xs']
    },
    {
      title: 'Age',
      dataIndex: 'age',
      key: 'age',
      width: 80,
      responsive: ['md']
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      responsive: ['lg'],
      ellipsis: true
    },
    {
      title: 'Contact',
      dataIndex: 'contact',
      key: 'contact',
      responsive: ['md'],
      width: 130
    },
    {
      title: 'Submitted',
      dataIndex: 'submittedAt',
      key: 'submittedAt',
      render: (date) => formatDate(date),
      responsive: ['md'],
      width: 120
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <Space direction="vertical" size="small">
          <Button
            type="primary"
            icon={<EyeOutlined />}
            onClick={() => onView(record)}
            size="small"
            block
          >
            View
          </Button>
          {canDelete && (
            <Button
              danger
              icon={<DeleteOutlined />}
              onClick={() => onDelete(record.id)}
              size="small"
              block
            >
              Delete
            </Button>
          )}
        </Space>
      ),
      width: 120,
      fixed: 'right'
    },
  ];

  return (
    <>
      <div style={{ marginBottom: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Space>
          <Button 
            onClick={onRefresh}
            loading={loading}
          >
            Refresh
          </Button>
          <Text type="secondary">
            Total Submissions: {submissions.length}
          </Text>
        </Space>
        <Space>
          {onEmailTemplatesClick && (
            <Button
              icon={<MailOutlined />}
              onClick={onEmailTemplatesClick}
            >
              Email Templates
            </Button>
          )}
          <Button
            icon={<SettingOutlined />}
            onClick={onConfigClick}
          >
            Form Settings
          </Button>
        </Space>
      </div>
      
      <Table
        columns={columns}
        dataSource={submissions}
        rowKey="id"
        loading={loading}
        pagination={{
          pageSize: 10,
          showSizeChanger: true,
          showQuickJumper: true,
          showTotal: (total, range) => 
            `${range[0]}-${range[1]} of ${total} submissions`,
        }}
        scroll={{ x: true }}
      />
    </>
  );
};

export default DanceOnTab;
